import { render, staticRenderFns } from "./_profile-preferences.vue?vue&type=template&id=07deeb8a&"
import script from "./_profile-preferences.vue?vue&type=script&lang=js&"
export * from "./_profile-preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports